<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">契合科技数字智能SCRM</div>
                            <div class="title">
                                全面专业的私域流量运营解决方案
                            </div>
                            <p class="sub-title">
                                契合科技SCRM平台，让企业轻松实现基于私域流量的客户关系管理，社群管理，并提供强大的营销工具包，适用于引流获客、促活留存、社交裂变等丰富多元的应用场景。
                            </p>
                            <p class="sub-title2">有记忆 数智化 全互联 可复用</p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                        <div class="nav-bars">
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/icon_1.png"
                                />
                                <div>
                                    <div class="txt">引流获客</div>
                                    <div class="subtxt">
                                        多元渠道，快速触达海量潜在客户
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/icon_2.png"
                                />
                                <div>
                                    <div class="txt">客户养成进阶</div>
                                    <div class="subtxt">
                                        多维客户画像，精准营销潜客转化进阶
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/icon_3.png"
                                />
                                <div>
                                    <div class="txt">智能社群运营</div>
                                    <div class="subtxt">
                                        轻松拉群，智能运营工具，高效群管理
                                    </div>
                                </div>
                            </div>
                            <div class="bar">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/icon_4.png"
                                />
                                <div>
                                    <div class="txt">企业风控</div>
                                    <div class="subtxt">
                                        监测敏感行为，降低违规违纪风险
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt163">
                <div class="dom-item">
                    <div class="dom-title">私域流量运营的痛点</div>
                    <div class="dom-content flex mt163">
                        <div class="p-item-wrap">
                            <div class="p-item">
                                <div class="p-item-title">获客成本高</div>
                                <div class="p-item-subtitle">
                                    缺乏精准导流的智能用户画像获取工具
                                </div>
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/line-l.png"
                                    class="line"
                                />
                                <div class="p-item-desc">
                                    互联网红利不复存在，在争夺存量用户时间的当下，难以区别不同阶段的用户画像，人工导流运营成本高，且容易造成用户流失。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">运营管理难度大</div>
                                <div class="p-item-subtitle">
                                    缺乏专业的私域流量运营管理系统
                                </div>
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/line-l.png"
                                    class="line"
                                />
                                <div class="p-item-desc">
                                    企微生态已经逐渐壮大，通过企微获取微信流量,
                                    并进行细分管理, 需要专业的平台型工具。
                                </div>
                            </div>
                        </div>
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/img1.png"
                            class="main-img1"
                        />
                        <div class="p-item-wrap">
                            <div class="p-item">
                                <div class="p-item-title">客户留存低</div>
                                <div class="p-item-subtitle">
                                    单一的活动策略难以沉淀高忠诚度用户
                                </div>
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/line_r.png"
                                    class="line"
                                />
                                <div class="p-item-desc">
                                    缺乏丰富性活动的策略，无法对用户进行分层，进而无法针对特定用户进行特定运营，难以沉淀出高忠诚用户。
                                </div>
                            </div>
                            <div class="p-item">
                                <div class="p-item-title">
                                    客户关系无法资产化
                                </div>
                                <div class="p-item-subtitle">
                                    客户关系容易随客户经理的流动而流失，难以有效转化为企业资产
                                </div>
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/line_r.png"
                                    class="line"
                                />
                                <div class="p-item-desc">
                                    客户经理岗位变化或离职等情况时，企业缺乏快速为客户匹配新的客户经理的渠道及工具，极易造成客户流失。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">我们的解决方案</div>
                    <div class="boxes">
                        <div class="box">
                            <div class="num-info">
                                <span class="num">01</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">精准触达客户</div>
                            <div class="txt">牢牢掌握客户线索资产</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">02</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">智能社群运营</div>
                            <div class="txt">减少人工高效便捷群管理</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">03</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">企业风险严格把控</div>
                            <div class="txt">保护企业信息资产</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">04</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">数据分析全面深入</div>
                            <div class="txt">记录用户行为深入分析</div>
                        </div>
                        <div class="box">
                            <div class="num-info">
                                <span class="num">05</span
                                ><span class="arr"></span>
                            </div>
                            <div class="txt">营销活动一站搭建</div>
                            <div class="txt">丰富高效的营销活动搭建</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap">
                <div class="dom-item">
                    <div class="main-img2">
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/img2.png"
                            class="main-img2-img"
                        />
                        <div class="content-item item1">
                            <div class="content-item-title">精准触达客户</div>
                            <div class="content-item-desc">
                                牢牢掌握客户线索资产
                            </div>
                        </div>
                        <div class="content-item item2">
                            <div class="content-item-title">营销一站搭建</div>
                            <div class="content-item-desc">
                                丰富、高效的营销活动搭建
                            </div>
                        </div>
                        <div class="content-item item3">
                            <div class="content-item-title">智能社群运营</div>
                            <div class="content-item-desc">
                                减少人工重复性工作，高效便捷群管理。
                            </div>
                        </div>
                        <div class="content-item item4">
                            <div class="content-item-title">
                                企业风险严格把控
                            </div>
                            <div class="content-item-desc">
                                全程管控沟通记录保护企业信息资产
                            </div>
                        </div>
                        <div class="content-item item5">
                            <div class="content-item-title">
                                数据分析全面深入
                            </div>
                            <div class="content-item-desc">
                                全面记录用户行为，深入分析，为运营工作提供详实的数据依据。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-2">
                <div class="dom-item">
                    <div v-for="(item, index) in List" :key="index">
                        <div
                            class="dom-title"
                            :class="index == 1 ? 'mb50' : ''"
                        >
                            {{ item.title }}
                        </div>
                        <div class="img-txt" :class="index == 1 ? 'mb50' : ''">
                            <div class="imgs">
                                <img
                                    :src="itemi.img"
                                    v-if="itemi.status == 1"
                                    v-for="(itemi, indexi) in item.desc"
                                    :key="indexi"
                                />
                                <!-- <img src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar1_1.png" v-if="item.desc[0].status == 1"/>
                                <img src="https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar1_2.png" v-if="item.desc[1].status == 1"/> -->
                            </div>
                            <div class="txts">
                                <div
                                    class="desc"
                                    :class="items.status == 1 ? 'on' : ''"
                                    v-for="(items, indexs) in item.desc"
                                    :key="indexs"
                                    @click="descTab(index, indexs)"
                                >
                                    <div class="intro-title">
                                        {{ items.intro_title }}
                                    </div>
                                    <div class="intro-content">
                                        <div class="intro-item-box">
                                            <div
                                                class="intro-item"
                                                v-for="(
                                                    itemx, indexx
                                                ) in items.introitem"
                                                :key="indexx"
                                            >
                                                <span class="gou"></span>
                                                <span class="intro-txt">{{
                                                    itemx.txt
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="desc">
                                    <div class="intro-title">
                                        【一客一码】 +【群活码】
                                    </div>
                                    <div class="intro-content">
                                        <div class="intro-item-box">
                                            <div class="intro-item">
                                                <span class="gou"></span>
                                                <span class="intro-txt">邀请轨迹全程追踪</span>
                                            </div>
                                            <div class="intro-item">
                                                <span class="gou"></span>
                                                <span class="intro-txt">群二维码长久有效</span>
                                            </div>
                                            <div class="intro-item">
                                                <span class="gou"></span>
                                                <span class="intro-txt">突破群成员数量限制</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <!-- <more :moreid="id"></more> -->
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            List: [
                {
                    title: "引流获客",
                    desc: [
                        {
                            intro_title:
                                "【企业微信名片】+ [好友欢迎语] +【新客红包】",
                            introitem: [
                                {
                                    txt: "对外统一企业形象",
                                },
                                {
                                    txt: "添加好友即刻响应",
                                },
                                {
                                    txt: "新客加入即时激励",
                                },
                            ],
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar1_1.png",
                            status: 1,
                        },
                        {
                            intro_title: "【一客一码】 +【群活码】",
                            introitem: [
                                {
                                    txt: "邀请轨迹全程追踪",
                                },
                                {
                                    txt: "群二维码长久有效",
                                },
                                {
                                    txt: "突破群成员数量限制",
                                },
                            ],
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar1_2.png",
                            status: 0,
                        },
                    ],
                },
                {
                    title: "促活留存",
                    desc: [
                        {
                            intro_title:
                                "【标签管理】+ 【客户画像】+ 【公共话术素材】",
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar2_1.png",
                            introitem: [
                                {
                                    txt: "牢牢掌控客户线索",
                                },
                                {
                                    txt: "多维标签精准客户画像",
                                },
                                {
                                    txt: "话术规范素材丰富",
                                },
                            ],
                            status: 1,
                        },
                        {
                            intro_title: "【群SOP推送】 +【客户群群发】",
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar2_2.png",
                            introitem: [
                                {
                                    txt: "运营工作流程化",
                                },
                                {
                                    txt: "批量群发有效触达",
                                },
                                {
                                    txt: "释放人力提高效率",
                                },
                            ],
                            status: 0,
                        },
                        {
                            intro_title:
                                "【签到/抽奖】+【养成/达标】+【超大营销活动库】",
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar2_3.png",
                            introitem: [
                                {
                                    txt: "签到/抽奖潜在客户促活",
                                },
                                {
                                    txt: "养成进阶持续向关联业务导流优质客户",
                                },
                            ],
                            status: 0,
                        },
                    ],
                },
                {
                    title: "社交裂变",
                    desc: [
                        {
                            intro_title:
                                "【邀请注册】+ 【组团消费】 +【推荐达标】",
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar3.png",
                            introitem: [
                                {
                                    txt: "分享邀请迅速扩大会员基数",
                                },
                                {
                                    txt: "持续裂变推升业务达标数据",
                                },
                            ],
                            status: 1,
                        },
                    ],
                },
                {
                    title: "企业风控",
                    desc: [
                        {
                            intro_title:
                                "【聊天存档】+【违规行为管控】+【敏感词过滤】",
                            img: "https://ccbhdimg.kerlala.com/hd/website/urthink/scrm/bar4.png",
                            introitem: [
                                {
                                    txt: "违规新智能监测",
                                },
                                {
                                    txt: "行为管控主动防御",
                                },
                            ],
                            status: 1,
                        },
                    ],
                },
            ],
            id: 4,
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
        descTab(val, desc) {
            console.log(val, desc);
            var list = this.List;
            list.forEach((item, index) => {
                if (val == index) {
                    console.log(item);
                    item.desc.forEach((items, indexs) => {
                        if (desc == indexs) {
                            items.status = 1;
                        } else {
                            items.status = 0;
                        }
                    });
                }
            });
        },
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-scrm.css";
</style>


// WEBPACK FOOTER //
// src/views/slg/scrm.vue